/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServizioMensaAnagraficaIscrizioneDTO } from './servizio-mensa-anagrafica-iscrizione-dto';


export interface ServizioMensaAnagraficaRowDTO { 
    /**
     * Id della riga ServizioMensaAnagrafica.
     */
    anagrafica_id?: string;
    nome?: string;
    cognome?: string;
    codice_fiscale?: string;
    email?: string;
    cellulare?: string;
    /**
     * Id della Pratica origine del genitore.
     */
    pratica_id?: string;
    /**
     * Macro-stato cittadino della Pratica origine.
     */
    stato_richiesta?: ServizioMensaAnagraficaRowDTOStatoRichiestaEnum;
    /**
     * Numero di studenti non sospesi dell\'anagrafica sul servizio.
     */
    studenti_attivi?: number;
    /**
     * Scuola, classe e sezione di ciascun figlio sul servizio, sospesi compresi.
     */
    iscrizioni?: Array<ServizioMensaAnagraficaIscrizioneDTO>;
    /**
     * true se il genitore ha cancellato il proprio account: non riceve piu\' le comunicazioni del servizio.
     */
    account_cancellato?: boolean;
}
export enum ServizioMensaAnagraficaRowDTOStatoRichiestaEnum {
    DA_COMPLETARE = 'DA_COMPLETARE',
    IN_VALUTAZIONE = 'IN_VALUTAZIONE',
    ACCETTATA = 'ACCETTATA',
    RIFIUTATA = 'RIFIUTATA'
};



